import { faSquareCheck } from '@fortawesome/free-solid-svg-icons'
import { faSquare } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import classNames from 'classnames'
import { chunk } from 'lodash'
import React from 'react'
import { Col, Row } from 'reactstrap'

import { DescriptionList, Item, ItemProps } from 'src/components/DescriptionList'
import { DropdownOption } from 'src/components/Forms'
import { yesno } from 'src/helpers/displayhelpers'
import { StaffingAgencyBenefitsById } from 'src/queries'

interface ListProps {
  agency: StaffingAgencyBenefitsById | undefined
  holidays?: DropdownOption[]
}

interface HolidaysProps {
  holidays?: DropdownOption[]
  selected?: Array<{
    _id: string
  }>
}

const Holidays: React.FC<HolidaysProps> = (props) => {
  const { holidays = [], selected = [] } = props
  return (
    <>
      {holidays.map((holiday, index) => {
        const isSelected = selected.find((item) => item._id === holiday.value) !== undefined
        const icon = isSelected ? faSquareCheck : faSquare
        return (
          <div key={String(holiday.value)} className={classNames({ 'fw-bold': isSelected })}>
            <small>
              <FontAwesomeIcon icon={icon} className='me-2' />
              {holiday.label}
            </small>
          </div>
        )
      })}
    </>
  )
}

const List: React.FC<ListProps> = (props) => {
  const { agency, holidays = [] } = props
  const benefits = agency?.staffingAgency?.benefits ?? { _holidays: [] }
  const holidaySections = chunk(holidays, holidays.length / 2)
  const section1: Array<Omit<ItemProps, 'id'>> = [
    { title: 'Payroll Run Time', value: benefits.payrollRunTime },
    { title: 'Health Benefits', value: yesno(benefits.healthBenefits) },
    { title: 'PTO', value: benefits.pto }
  ]
  const holidayItem: ItemProps = {
    title: 'Holidays',
    id: 'holidays',
    value: (
      <Row>
        {holidaySections.map((section, index) => (
          <Col key={index} md='6'>
            <Holidays holidays={section} selected={benefits._holidays} />
          </Col>
        ))}
      </Row>
    )
  }
  const dlProps = {
    className: 'row-cols-1',
    suspended: agency === undefined,
    titleProps: { lg: 'auto' },
    valueProps: { lg: 'auto', className: 'mb-lg-0 mb-md-1 mb-3' }
  }
  const holidayDlProps = {
    ...dlProps,
    titleProps: { xs: '12' },
    valueProps: {
      ...dlProps.valueProps,
      lg: '12'
    }
  }
  return (
    <Row>
      <Col>
        <DescriptionList {...dlProps}>
          {section1.map(item => {
            const key = item.title.toLowerCase().replace(' ', '-')
            return <Item {...item} key={key} id={key} />
          })}
        </DescriptionList>
        <DescriptionList {...holidayDlProps}>
          <Item {...holidayItem} />
        </DescriptionList>
      </Col>
    </Row>
  )
}

export default List
